import {
  TechDocsAddonLocations,
  createTechDocsAddonExtension,
} from '@backstage/plugin-techdocs-react';
import { techdocsPlugin } from '@backstage/plugin-techdocs';
import { ShadowStyles } from './ShadowStyles';

/**
 * The portal's documentation styling, as a TechDocs addon (DX-275).
 *
 * Registered in the `Content` location because that is where the reader's
 * shadow root exists; the component renders nothing itself and only appends a
 * stylesheet there. See ShadowStyles for why an addon is needed at all.
 */
export const RevenexxDocsStyles = techdocsPlugin.provide(
  createTechDocsAddonExtension({
    name: 'RevenexxDocsStyles',
    location: TechDocsAddonLocations.Content,
    component: ShadowStyles,
  }),
);
